import type { ReactNode } from "react";
import { Toaster } from "@porchpass/ui";
import { AuthProvider } from "./AuthContext";
import { UserProvider } from "./UserContext";
import { usePersistedAppStore } from "src/hooks";

export const AppProviders = ({ children }: { children: ReactNode }) => {
  const PersistedAppStore = usePersistedAppStore();

  return (
    <AuthProvider>
      <UserProvider value={PersistedAppStore}>
        {children}
        <Toaster />
      </UserProvider>
    </AuthProvider>
  );
};
